// Terms of service. Friendly tone, short sections, no surprises.

import { LegalLayout } from "./LegalLayout";

export function TermsPage() {
  return (
    <LegalLayout
      title="Terms"
      revisedAt="May 24, 2026"
      current="terms"
    >
      <p>
        These terms cover the things we both agree to when you use
        Link. They aren't trying to be tricky — read them, hold us
        to them.
      </p>

      <h2>The deal</h2>
      <p>
        We provide Link "as is" and try to keep it running. You
        bring your own recovery phrase and play by the community
        rules below. Either of us can end the relationship at any
        time: you delete your account; we close accounts that
        violate the rules.
      </p>

      <h2>What you can't do</h2>
      <ul>
        <li>
          Sexual content involving minors. Zero tolerance — we
          report and remove without notice.
        </li>
        <li>
          Doxxing, mass harassment, or coordinated targeting of an
          individual.
        </li>
        <li>
          Building or distributing malware, exploits, or
          credential-stealing payloads.
        </li>
        <li>
          Using Link to facilitate trafficking, fraud, or threats
          of physical harm.
        </li>
        <li>
          Attempting to break the cryptographic boundary — for
          example by spoofing other users' public keys.
        </li>
      </ul>

      <h2>Reports and bans</h2>
      <p>
        Anyone in a shared workspace or community can report a
        message. Operators review reports and may ban accounts
        that violate the rules. Bans end any active sessions on
        the account immediately.
      </p>

      <h2>Your content</h2>
      <p>
        You own what you create. We need the smallest license
        possible to deliver it: store the bytes you sent us,
        forward them to the recipients you picked, and (for
        shared-workspace / community channels) index them for
        search inside that Space. Personal Workspace, DM, and
        Secrets content stays end-to-end encrypted; we have no
        plaintext to license.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        Link is provided without warranty. We aren't liable for
        indirect or consequential damages. To the extent the law
        lets us cap our liability, our total liability is the
        amount you paid us in the past 12 months — which, for
        v1, is zero.
      </p>

      <h2>Changes</h2>
      <p>
        We'll update the changelog on the{" "}
        <a href="/transparency">Transparency page</a> and the
        "last revised" date above when these terms change. Big
        changes will be flagged at the top of the app.
      </p>
    </LegalLayout>
  );
}
